/**
 * AboutShapes + ServicesShapes — visually-distinct layout primitives
 * for the About and Services categories. Iter 148 Phase 1.
 */
import React from 'react';

const IMG = {
  founder: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=400&q=70',
  studio:  'https://images.unsplash.com/photo-1517292987719-0369a794ec0f?w=600&q=70',
  team:    'https://images.unsplash.com/photo-1521737711867-e3b97375f902?w=600&q=70',
  service: 'https://images.unsplash.com/photo-1581094288338-2314dddb7ece?w=600&q=70',
  service2:'https://images.unsplash.com/photo-1607472586893-edb57bdc0e39?w=600&q=70',
};

const Line = ({ w = '60%', mt = 4, color = '#CBD5E1' }) =>
  <div style={{ width: w, height: 2.5, background: color, borderRadius: 2, marginTop: mt }} />;

// ════════════════════════════════════════════════════════════════════
// ABOUT SHAPES (8)
// ════════════════════════════════════════════════════════════════════

export const FounderLetter = () => (
  <div style={{display:'flex',width:'100%',height:'100%',background:'#FAF6EE'}}>
    <div style={{flex:0.9,padding:14,display:'flex',flexDirection:'column',justifyContent:'center'}}>
      <img src={IMG.founder} alt="" style={{width:32,height:32,borderRadius:999,objectFit:'cover',marginBottom:8}}/>
      <div style={{fontSize:5,letterSpacing:1.2,color:'#8B5CF6',fontWeight:900,textTransform:'uppercase'}}>A letter from</div>
      <div style={{fontSize:9,fontWeight:900,color:'#0E0E23',marginTop:1}}>Sarah, our founder</div>
    </div>
    <div style={{flex:1.4,padding:14,paddingLeft:0,display:'flex',flexDirection:'column',justifyContent:'center'}}>
      <div style={{fontSize:7,fontFamily:'Georgia, serif',color:'#0E0E23',lineHeight:1.5,fontStyle:'italic'}}>
        &ldquo;I started this in my kitchen in 2021. Today we ship to 14 countries and still hand-write every note. That hasn&rsquo;t changed. It won&rsquo;t.&rdquo;
      </div>
      <Line w="40%" mt={8}/>
    </div>
  </div>
);

export const ValuesGrid = () => (
  <div style={{background:'#fff',width:'100%',height:'100%',padding:14}}>
    <div style={{fontSize:9,fontWeight:900,color:'#0E0E23',marginBottom:8}}>What we stand for</div>
    <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gridTemplateRows:'1fr 1fr',gap:5}}>
      {['Craft','Honesty','People','Earth'].map((v,i)=>(
        <div key={i} style={{padding:8,background:i%2?'#F8FAFC':'#FAF4EB',borderRadius:5}}>
          <div style={{fontSize:11,fontWeight:900,color:'#0E0E23'}}>0{i+1}.</div>
          <div style={{fontSize:7,fontWeight:900,color:'#0E0E23',marginTop:2}}>{v}</div>
          <Line w="80%" mt={3}/>
        </div>
      ))}
    </div>
  </div>
);

export const Timeline = () => (
  <div style={{background:'#fff',width:'100%',height:'100%',padding:14}}>
    <div style={{fontSize:9,fontWeight:900,color:'#0E0E23',marginBottom:10}}>Our journey</div>
    {[
      {y:'2021',t:'Founded in Brooklyn'},
      {y:'2022',t:'Opened first studio'},
      {y:'2024',t:'Crossed 5,000 clients'},
      {y:'2026',t:'Global expansion'},
    ].map((s,i)=>(
      <div key={i} style={{display:'flex',gap:8,position:'relative',paddingBottom:8}}>
        <div style={{minWidth:24,fontSize:9,fontWeight:900,color:'#8B5CF6'}}>{s.y}</div>
        <div style={{flex:1,fontSize:6,color:'#0E0E23'}}>{s.t}<Line w="70%" mt={2}/></div>
      </div>
    ))}
  </div>
);

export const MissionFocus = () => (
  <div style={{background:'#0E0E23',color:'#fff',width:'100%',height:'100%',padding:18,display:'flex',flexDirection:'column',justifyContent:'center'}}>
    <div style={{fontSize:5,letterSpacing:2,fontWeight:900,opacity:0.6}}>OUR MISSION</div>
    <div style={{fontSize:18,fontFamily:'Georgia, serif',lineHeight:1.15,marginTop:8,letterSpacing:-0.3}}>
      To make every interaction <em style={{color:'#F59E0B'}}>genuinely useful</em> and <em style={{color:'#F59E0B'}}>quietly beautiful.</em>
    </div>
  </div>
);

export const Statistics = () => (
  <div style={{background:'#F8FAFC',width:'100%',height:'100%',padding:14,display:'flex',flexDirection:'column',justifyContent:'center'}}>
    <div style={{fontSize:9,fontWeight:900,color:'#0E0E23',textAlign:'center',marginBottom:10}}>Impact in numbers</div>
    <div style={{display:'grid',gridTemplateColumns:'1fr 1fr 1fr 1fr',gap:6,textAlign:'center'}}>
      {[{v:'15K+',l:'Clients'},{v:'94%',l:'Retain'},{v:'42',l:'Countries'},{v:'5★',l:'Avg'}].map((s,i)=>(
        <div key={i}>
          <div style={{fontSize:16,fontWeight:900,color:'#8B5CF6'}}>{s.v}</div>
          <div style={{fontSize:5,color:'#6B7280',letterSpacing:1,textTransform:'uppercase',marginTop:2}}>{s.l}</div>
        </div>
      ))}
    </div>
  </div>
);

export const AboutImageCollage = () => (
  <div style={{display:'grid',gridTemplateColumns:'1.4fr 1fr',width:'100%',height:'100%',background:'#fff'}}>
    <div style={{padding:14,display:'flex',flexDirection:'column',justifyContent:'center'}}>
      <div style={{fontSize:5,fontWeight:900,letterSpacing:1.5,color:'#8B5CF6',textTransform:'uppercase'}}>About us</div>
      <div style={{fontSize:13,fontWeight:900,color:'#0E0E23',marginTop:5,lineHeight:1}}>A small studio<br/>thinking big.</div>
      <Line w="80%" mt={6}/><Line w="60%" mt={3}/><Line w="70%" mt={3}/>
    </div>
    <div style={{display:'grid',gridTemplateRows:'1fr 1fr',gap:3,padding:3}}>
      <img src={IMG.studio} alt="" style={{width:'100%',height:'100%',objectFit:'cover'}}/>
      <img src={IMG.team} alt="" style={{width:'100%',height:'100%',objectFit:'cover'}}/>
    </div>
  </div>
);

export const SplitStory = () => (
  <div style={{display:'flex',flexDirection:'column',width:'100%',height:'100%',background:'#fff'}}>
    <img src={IMG.team} alt="" style={{width:'100%',height:'55%',objectFit:'cover'}}/>
    <div style={{flex:1,padding:'10px 14px',display:'flex',flexDirection:'column',justifyContent:'center'}}>
      <div style={{fontSize:9,fontWeight:900,color:'#0E0E23',lineHeight:1}}>Built by hand. Backed by craft.</div>
      <Line w="80%" mt={5}/><Line w="60%" mt={3}/>
    </div>
  </div>
);

export const AlternatingStory = () => (
  <div style={{width:'100%',height:'100%',background:'#FAF6EE',padding:8,display:'flex',flexDirection:'column',gap:5}}>
    {[1,2].map((row)=>(
      <div key={row} style={{display:'flex',gap:6,flexDirection:row===2?'row-reverse':'row',flex:1}}>
        <img src={row===1?IMG.studio:IMG.team} alt="" style={{width:'46%',height:'100%',objectFit:'cover',borderRadius:4}}/>
        <div style={{flex:1,display:'flex',flexDirection:'column',justifyContent:'center',padding:'0 8px'}}>
          <div style={{fontSize:8,fontWeight:900,color:'#0E0E23'}}>{row===1?'2021 · Begin':'2024 · Grow'}</div>
          <Line w="80%" mt={4}/><Line w="60%" mt={3}/>
        </div>
      </div>
    ))}
  </div>
);

// ════════════════════════════════════════════════════════════════════
// SERVICES SHAPES (8)
// ════════════════════════════════════════════════════════════════════

export const ServicesIconFeatures = () => (
  <div style={{background:'#fff',width:'100%',height:'100%',padding:14}}>
    <div style={{fontSize:9,fontWeight:900,color:'#0E0E23',textAlign:'center',marginBottom:8}}>What we do</div>
    <div style={{display:'grid',gridTemplateColumns:'1fr 1fr 1fr 1fr',gap:6}}>
      {[{i:'✦',t:'Brand'},{i:'◐',t:'Strategy'},{i:'◑',t:'Design'},{i:'✚',t:'Build'}].map((c,i)=>(
        <div key={i} style={{textAlign:'center',padding:6}}>
          <div style={{fontSize:18,color:'#8B5CF6'}}>{c.i}</div>
          <div style={{fontSize:6,fontWeight:900,color:'#0E0E23',marginTop:3}}>{c.t}</div>
          <Line w="60%" mt={3}/>
        </div>
      ))}
    </div>
  </div>
);

export const ServicesAlternatingRows = () => (
  <div style={{width:'100%',height:'100%',background:'#fff',padding:6,display:'flex',flexDirection:'column',gap:4}}>
    {[1,2].map(r=>(
      <div key={r} style={{display:'flex',flexDirection:r===2?'row-reverse':'row',flex:1,gap:6,background:r%2?'#FAF6EE':'transparent',padding:6,borderRadius:4}}>
        <img src={r===1?IMG.service:IMG.service2} alt="" style={{width:'40%',height:'100%',objectFit:'cover',borderRadius:4}}/>
        <div style={{flex:1,padding:'2px 6px'}}>
          <div style={{fontSize:5,letterSpacing:1.2,color:'#8B5CF6',fontWeight:900,textTransform:'uppercase'}}>0{r}.</div>
          <div style={{fontSize:9,fontWeight:900,color:'#0E0E23',marginTop:2}}>{r===1?'Brand Identity':'Web & Product'}</div>
          <Line w="80%" mt={3}/><Line w="60%" mt={3}/>
        </div>
      </div>
    ))}
  </div>
);

export const ServicesTimeline = () => (
  <div style={{background:'#F8FAFC',width:'100%',height:'100%',padding:14}}>
    <div style={{fontSize:9,fontWeight:900,color:'#0E0E23',marginBottom:8}}>Our process</div>
    <div style={{display:'grid',gridTemplateColumns:'1fr 1fr 1fr 1fr',gap:4,position:'relative'}}>
      <div style={{position:'absolute',top:13,left:14,right:14,height:1,background:'#CBD5E1'}}/>
      {['Discover','Design','Build','Launch'].map((s,i)=>(
        <div key={i} style={{textAlign:'center',position:'relative'}}>
          <div style={{width:14,height:14,borderRadius:999,background:i===1?'#8B5CF6':'#fff',border:'2px solid #8B5CF6',margin:'0 auto',display:'flex',alignItems:'center',justifyContent:'center',color:i===1?'#fff':'#8B5CF6',fontSize:6,fontWeight:900,position:'relative',zIndex:1}}>{i+1}</div>
          <div style={{fontSize:6,fontWeight:900,color:'#0E0E23',marginTop:4}}>{s}</div>
        </div>
      ))}
    </div>
  </div>
);

export const ServicesComparison = () => (
  <div style={{background:'#fff',width:'100%',height:'100%',padding:10}}>
    <div style={{display:'grid',gridTemplateColumns:'1.2fr 1fr 1fr',fontSize:5,fontWeight:900,letterSpacing:1,textTransform:'uppercase',color:'#0E0E23',borderBottom:'1px solid #0E0E23',paddingBottom:4}}>
      <div></div><div style={{textAlign:'center'}}>Basic</div><div style={{textAlign:'center',color:'#8B5CF6'}}>Pro</div>
    </div>
    {[1,2,3,4].map(i=>(
      <div key={i} style={{display:'grid',gridTemplateColumns:'1.2fr 1fr 1fr',padding:'5px 0',borderBottom:'1px solid #F1F5F9',fontSize:6,color:'#0E0E23',alignItems:'center'}}>
        <Line w="65%" mt={0}/>
        <div style={{textAlign:'center'}}>✓</div>
        <div style={{textAlign:'center',color:'#8B5CF6',fontWeight:900}}>✓</div>
      </div>
    ))}
  </div>
);

export const ServicesLargeFeature = () => (
  <div style={{display:'flex',width:'100%',height:'100%',background:'#0E0E23',color:'#fff'}}>
    <img src={IMG.service} alt="" style={{width:'55%',height:'100%',objectFit:'cover'}}/>
    <div style={{flex:1,padding:14,display:'flex',flexDirection:'column',justifyContent:'center'}}>
      <div style={{fontSize:5,letterSpacing:1.5,color:'#F97316',fontWeight:900,textTransform:'uppercase'}}>Featured</div>
      <div style={{fontSize:13,fontWeight:900,marginTop:4,lineHeight:1}}>Full Service<br/>Brand System</div>
      <Line w="70%" color="rgba(255,255,255,0.4)" mt={6}/>
      <Line w="55%" color="rgba(255,255,255,0.4)" mt={3}/>
      <div style={{marginTop:8,display:'inline-block',background:'#F97316',color:'#fff',padding:'5px 10px',borderRadius:999,fontSize:7,fontWeight:900,letterSpacing:0.5,textTransform:'uppercase',width:'fit-content'}}>From $4,800 →</div>
    </div>
  </div>
);

export const ServicesTabbed = () => (
  <div style={{background:'#fff',width:'100%',height:'100%',padding:10}}>
    <div style={{display:'flex',gap:4,borderBottom:'1px solid #E2E8F0',paddingBottom:0}}>
      {['Branding','Design','Build','Care'].map((t,i)=>(
        <div key={i} style={{padding:'4px 8px',fontSize:6,fontWeight:900,letterSpacing:0.6,textTransform:'uppercase',color:i===0?'#0E0E23':'#9CA3AF',borderBottom:i===0?'2px solid #0E0E23':'2px solid transparent',marginBottom:-1}}>{t}</div>
      ))}
    </div>
    <div style={{paddingTop:8,display:'grid',gridTemplateColumns:'1fr 1fr',gap:10}}>
      <img src={IMG.service2} alt="" style={{width:'100%',height:80,objectFit:'cover',borderRadius:4}}/>
      <div>
        <div style={{fontSize:8,fontWeight:900,color:'#0E0E23'}}>Brand Identity Systems</div>
        <Line w="90%" mt={4}/><Line w="70%" mt={3}/><Line w="50%" mt={3}/>
      </div>
    </div>
  </div>
);

export const ServicesCardsLarge = () => (
  <div style={{background:'#FAF6EE',width:'100%',height:'100%',padding:10,display:'grid',gridTemplateColumns:'1fr 1fr',gap:6}}>
    {[1,2,3,4].map(i=>(
      <div key={i} style={{background:'#fff',padding:6,borderRadius:5,boxShadow:'0 1px 4px rgba(0,0,0,0.06)'}}>
        <div style={{fontSize:11,color:'#8B5CF6',fontWeight:900}}>0{i}</div>
        <div style={{fontSize:6,fontWeight:900,color:'#0E0E23',marginTop:3}}>{['Brand','Web','SEO','Care'][i-1]}</div>
        <Line w="80%" mt={3}/>
      </div>
    ))}
  </div>
);

export const ServicesPricingFocus = () => (
  <div style={{background:'#fff',width:'100%',height:'100%',padding:14,display:'flex',flexDirection:'column'}}>
    <div style={{fontSize:9,fontWeight:900,color:'#0E0E23'}}>Pick your package</div>
    <div style={{flex:1,display:'grid',gridTemplateColumns:'1fr 1.2fr 1fr',gap:6,alignItems:'center',marginTop:8}}>
      {[{n:'Starter',p:'$2.4k'},{n:'Studio',p:'$6.8k',hi:true},{n:'Enterprise',p:'$18k'}].map((t,i)=>(
        <div key={i} style={{background:t.hi?'#0E0E23':'#F8FAFC',color:t.hi?'#fff':'#0E0E23',padding:10,borderRadius:6,textAlign:'center',transform:t.hi?'scale(1.05)':'none'}}>
          <div style={{fontSize:5,letterSpacing:1,textTransform:'uppercase',fontWeight:900,opacity:0.7}}>{t.n}</div>
          <div style={{fontSize:14,fontWeight:900,marginTop:3}}>{t.p}</div>
          <div style={{marginTop:6,fontSize:6,padding:'3px 0',borderRadius:3,background:t.hi?'#F97316':'#0E0E23',color:'#fff',fontWeight:900}}>SELECT</div>
        </div>
      ))}
    </div>
  </div>
);

// ── Iter 189c Phase B — new premium About variants (drawn miniatures) ──
const FounderStoryPhoto = () => (
  <div style={{ display:'flex', width:'100%', height:'100%' }}>
    <div style={{ width:'55%', background:'#DDD', position:'relative' }}>
      <img src="https://images.unsplash.com/photo-1580489944761-15a19d654956?w=800&q=70" alt="" style={{ width:'100%', height:'100%', objectFit:'cover' }} />
    </div>
    <div style={{ width:'45%', background:'#FAF6EE', padding:14, display:'flex', flexDirection:'column', justifyContent:'center' }}>
      <div style={{ fontSize:6, color:'#8B5CF6', fontWeight:800, letterSpacing:1.2, textTransform:'uppercase' }}>MEET</div>
      <div style={{ fontSize:20, fontWeight:900, color:'#0E0E23', marginTop:5, lineHeight:1.05, fontFamily:'Georgia,serif' }}>Maya Cortez</div>
      <div style={{ fontSize:7, fontStyle:'italic', color:'#0E0E23', opacity:0.75, marginTop:6, lineHeight:1.4, fontFamily:'Georgia,serif' }}>&quot;Design that respects the past…&quot;</div>
      <div style={{ fontSize:6, color:'#475569', marginTop:6, lineHeight:1.4 }}>Six years ago I set out to build products that felt hand-crafted.</div>
    </div>
  </div>
);

const CollageValues = () => (
  <div style={{ background:'#fff', width:'100%', height:'100%', padding:10, display:'flex', flexDirection:'column' }}>
    <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gap:4, height:'50%' }}>
      {['https://images.unsplash.com/photo-1483985988355-763728e1935b?w=400&q=70',
        'https://images.unsplash.com/photo-1521737711867-e3b97375f902?w=400&q=70',
        'https://images.unsplash.com/photo-1467043153537-a4fba2cd39ef?w=400&q=70'].map((src, i) => (
        <img key={i} src={src} alt="" style={{ width:'100%', height:'100%', objectFit:'cover', borderRadius:4, transform: i===1 ? 'translateY(6px)' : 'none' }} />
      ))}
    </div>
    <div style={{ textAlign:'center', marginTop:12 }}>
      <div style={{ fontSize:6, color:'#8B5CF6', fontWeight:800, letterSpacing:1.2, textTransform:'uppercase' }}>WHY IT MATTERS</div>
      <div style={{ fontSize:12, fontWeight:900, color:'#0E0E23', marginTop:3 }}>Three things we care about.</div>
    </div>
    <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gap:6, marginTop:8 }}>
      {['Handcraft', 'Provenance', 'Longevity'].map((t, i) => (
        <div key={i} style={{ textAlign:'center' }}>
          <div style={{ fontSize:8, color:'#8B5CF6', fontWeight:900, fontFamily:'Georgia,serif' }}>{String(i+1).padStart(2,'0')}.</div>
          <div style={{ fontSize:6, fontWeight:800, color:'#0E0E23' }}>{t}</div>
        </div>
      ))}
    </div>
  </div>
);

export const ABOUT_SHAPE_BY_ID = {
  'founder-letter':     FounderLetter,
  'values-grid':        ValuesGrid,
  'timeline':           Timeline,
  'mission-focus':      MissionFocus,
  'statistics':         Statistics,
  'image-collage':      AboutImageCollage,
  'split-story':        SplitStory,
  'alternating-story':  AlternatingStory,
  // Iter 189c Phase B — new premium About variants
  'founder-story-photo': FounderStoryPhoto,
  'collage-values':      CollageValues,
};

// ── Iter 189c Phase B · Services — new premium variants (drawn thumbnails) ──
export const ServicesBentoGrid = () => (
  <div style={{ background:'#fff', width:'100%', height:'100%', padding:8 }}>
    <div style={{ textAlign:'center', marginBottom:6 }}>
      <div style={{ fontSize:5, color:'#8B5CF6', fontWeight:800, letterSpacing:1.2, textTransform:'uppercase' }}>HOW WE HELP</div>
      <div style={{ fontSize:9, fontWeight:900, color:'#0E0E23', marginTop:1 }}>Everything you need.</div>
    </div>
    <div style={{ display:'grid', gridTemplateColumns:'2fr 1fr 1fr', gridTemplateRows:'1fr 1fr', gap:3, height:'calc(100% - 30px)' }}>
      <div style={{ gridRow:'span 2', background:'#EDE9FE', borderRadius:4, padding:6, display:'flex', flexDirection:'column', justifyContent:'flex-end' }}>
        <div style={{ fontSize:16, opacity:0.7 }}>◐</div>
        <div style={{ fontSize:7, fontWeight:900, color:'#0E0E23', marginTop:3 }}>Brand identity</div>
      </div>
      {['◈','◉','✦','⬗'].map((ic, i) => (
        <div key={i} style={{ background:'#F8FAFC', border:'1px solid #E2E8F0', borderRadius:4, padding:5, display:'flex', flexDirection:'column', justifyContent:'space-between' }}>
          <div style={{ fontSize:8, opacity:0.7 }}>{ic}</div>
          <div style={{ fontSize:5, fontWeight:800, color:'#0E0E23' }}>{['Web','Copy','Photo','Launch'][i]}</div>
        </div>
      ))}
    </div>
  </div>
);

export const ServicesFeaturedShowcase = () => (
  <div style={{ display:'flex', width:'100%', height:'100%', background:'#fff', padding:8, gap:8, alignItems:'center' }}>
    <div style={{ flex:1 }}>
      <div style={{ fontSize:5, color:'#8B5CF6', fontWeight:800, letterSpacing:1.2, textTransform:'uppercase' }}>SIGNATURE SERVICE</div>
      <div style={{ fontSize:10, fontWeight:900, color:'#0E0E23', marginTop:3, lineHeight:1.1 }}>End-to-end brand builds.</div>
      <div style={{ display:'flex', flexDirection:'column', gap:2, marginTop:5 }}>
        {['Workshop + strategy','Full identity','Website + shoots','Launch care'].map((b,i)=>(
          <div key={i} style={{ display:'flex', gap:3, alignItems:'center' }}>
            <div style={{ width:6, height:6, borderRadius:99, background:'#8B5CF6', color:'#fff', fontSize:4, display:'flex', alignItems:'center', justifyContent:'center' }}>✓</div>
            <div style={{ fontSize:5, color:'#475569' }}>{b}</div>
          </div>
        ))}
      </div>
      <div style={{ display:'inline-block', marginTop:5, background:'#0E0E23', color:'#fff', fontSize:5, fontWeight:800, padding:'3px 6px', borderRadius:99 }}>Book a call →</div>
    </div>
    <div style={{ flex:1.2, aspectRatio:'4/5' }}>
      <img src="https://images.unsplash.com/photo-1600880292203-757bb62b4baf?w=400&q=70" alt="" style={{ width:'100%', height:'100%', objectFit:'cover', borderRadius:4 }} />
    </div>
  </div>
);

export const SERVICES_SHAPE_BY_ID = {
  'icon-features':      ServicesIconFeatures,
  'alternating-rows':   ServicesAlternatingRows,
  'timeline':           ServicesTimeline,
  'comparison':         ServicesComparison,
  'large-feature':      ServicesLargeFeature,
  'tabbed':             ServicesTabbed,
  'cards-large':        ServicesCardsLarge,
  'pricing-focus':      ServicesPricingFocus,
  // Iter 189c Phase B — new premium Services variants
  'bento-grid':         ServicesBentoGrid,
  'featured-showcase':  ServicesFeaturedShowcase,
};
